import * as React from "react"
import {createRoot} from 'react-dom/client';
import {flushSync} from 'react-dom';
import {Skeleton} from "@mui/material";
import {BubbleAmchartSeeker} from "@ui-seeker/core";
import {normalizeCountryName, translateCountryName} from "@ui-seeker/utils";

import {TitleWithPopover} from "@components";
import {usePriceDiscountCountryWiseData, usePriceDiscountCountryWiseText} from "./@hooks";
import CountryWiseTooltip from "./Tooltip";
import {PriceDiscountGroupedByToggleButton} from "../index";


const HEIGHT = 500

const tooltipHTML = document.createElement('div');
const root = createRoot(tooltipHTML);

flushSync(() => root.render(<CountryWiseTooltip />))

export default function PriceDiscountCountryWise() {
	const { isLoading, data } = usePriceDiscountCountryWiseData()
	const { title, titleX, titleY } = usePriceDiscountCountryWiseText()

	if (isLoading) return <Skeleton variant="rectangular" height={HEIGHT} />
	if (!data.length) return <></>

	return <BubbleAmchartSeeker
		rootID="bubbleChart"
		title={<TitleWithPopover title={title} />}
		data={data.slice(0, 10).map(({ country, ...dataProps }) => ({
			...dataProps,
			countryCode: country ? normalizeCountryName(country) : '',
			country: country ? translateCountryName(country) : ''
		}))}
		series={[{
			xField: 'avgDiscount',
			yField: 'hasDiscount',
			value: 'numSkus',
			tooltip: { labelHTML: tooltipHTML.innerHTML }
		}]}
		cardProps={{
			actions: <PriceDiscountGroupedByToggleButton />
		}}
		chartProps={{
			enabledPDF: false,
			numberFormat: "#",
			xAxis: {
				numberFormat: "#'%'",
				title: titleX,
				strictMinMax: true
			},
			yAxis: {
				min: 0,
				title: titleY
			}
		}}
	/>
}